// src/utils/auth.js
import { jwtDecode } from "jwt-decode";

export const getTokenFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const t = params.get("token");
  if (t) {
    window.history.replaceState({}, "", window.location.origin + window.location.pathname);
  }
  return t;
};

export const getJwtExp = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return exp || null;
  } catch {
    return null;
  }
};

export const isJwtExpired = (token) => {
  const exp = getJwtExp(token);
  if (exp === null) return true;
  return Math.floor(Date.now() / 1000) >= exp;
};

/** Identity hint only. Server authorization always verifies the signed JWT. */
export const accessUserId = (token) => {
  try {
    const id = jwtDecode(token)?.id;
    return /^[a-f0-9]{24}$/i.test(String(id || "")) ? String(id).toLowerCase() : null;
  } catch {
    return null;
  }
};
